class AnalyticsReports {

  constructor(basePath, apiClient) {
    this.basePath = `${basePath}/reports`;
    this.apiClient = apiClient;
  }

  async createReport() {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, {});

  }

  async publishReportById(reportId, report) {

    const path = `${this.basePath}/:reportId/publish`;

    return this.apiClient.put(path, { reportId }, {}, report);

  }

  async updateReportBasicDetailsById(reportId, details) {

    const path = `${this.basePath}/:reportId/basic-details`;

    return this.apiClient.put(path, { reportId }, {}, details);

  }

  async updateReportCriteriaById(reportId, criteria) {

    const path = `${this.basePath}/:reportId/criteria`;

    return this.apiClient.put(path, { reportId }, {}, criteria);

  }

  async getPublishedReports(queryOptions) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async getPublishedReportById(reportId, projection) {

    const path = `${this.basePath}/:reportId`;

    return this.apiClient.get(path, { reportId }, { projection });

  }

  async deleteAnalyticsReportById(reportId, ) {

    const path = `${this.basePath}/:reportId`;

    return this.apiClient.delete(path, { reportId }, {});

  }

}

export default AnalyticsReports;